import { httpClientPrivate } from '@/libs/httpClient'
import config from '@/config'
import { useQuery } from '@tanstack/react-query'
import { HealthClaimAutoAssignmentResponse } from './types'

const fetchHealthClaimAutoAssignment = async (params: {
  search: string
  page: number
  limit: number
}) => {
  const search = params.search ? `search=${params.search}&` : ''

  const response = await httpClientPrivate.get<HealthClaimAutoAssignmentResponse>(
    `${config.restUrl}/v1/backoffice/pool/health-claim-auto-assignment/members?${search}page=${params.page}&limit=${params.limit}`,
  )

  return response.data
}

const useHealthClaimAutoAssignment = (params: {
  search: string
  page: number
  limit: number
  enabled: boolean
}) => {
  const queryKey = ['useHealthClaimAutoAssignment', params]
  const queryFn = async () => fetchHealthClaimAutoAssignment(params)
  const queryResult = useQuery({ queryKey, queryFn, enabled: params.enabled })

  return { ...queryResult }
}

export { fetchHealthClaimAutoAssignment, useHealthClaimAutoAssignment }
